import ICompany, { ICompanyScoreHistory, ITimeseries } from '../types/company';

export const formatCompanyData = (company: ICompanyScoreHistory, pageDateRange: { earliestDate: string }): ICompany => {
  const timeseries: ITimeseries[] = [];
  let previousScore: number | null = null;
  const earliestDate = new Date(pageDateRange.earliestDate);
  const currentDate = new Date(company.timeseriesStartDate.getTime());

  // this is a fix for a scenario that _should_ never be possible (i.e. a user has managed to select an area of the graph
  // where the earliest date visible would be less than the earliest date in our company's timeseries data
  // We handle this by providing the zeroed data that we would also get for missing data in the valid date range.
  while (earliestDate < company.timeseriesStartDate) {
    timeseries.push({
      score: 0,
      total: 0,
      negative: 0,
      date: earliestDate.toISOString().split('T')[0],
    });
    earliestDate.setDate(earliestDate.getDate() + 1);
  }

  for (let i = 0; i < company.timeseries.length; i++) {
    // ignore timeseries before earliest date in graph x-range
    if (currentDate >= earliestDate) {
      const scoreValue = company.timeseries[i];
      const isEstimated = company.estimated[i];

      let score: number;

      if (scoreValue !== null) {
        // Take `main` value if it's not null
        score = scoreValue;
        previousScore = scoreValue;
      } else if (previousScore !== null) {
        // If both `main` and `estimate` are null, use the previous value
        score = previousScore;
      } else {
        // Handle edge case if both `main` and `estimate` are null with no previous value
        score = 0;
      }

      const total = isEstimated ? 0 : 100;

      const formattedDate = currentDate.toISOString().split('T')[0];
      timeseries.push({ score, total, negative: 0, date: formattedDate });
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return {
    company_code: company.company_code,
    name: company.name,
    country: company.country,
    industry_sector: company.industry_sector,
    time_series: timeseries,
  };
};
